import React from 'react'
import * as Icons from 'react-icons/gi'

class GamesIcon extends React.Component {

  render() {

    const backgroundColor = this.props.backgroundColor
    const name = this.props.name //'GiFigurehead'
    const gamesIcon = Icons[name]
    const color = this.props.color

    return(
      <div>
        {React.createElement(gamesIcon, 
          {
            color:color, 
            style: 
            {
              width:'80px',
              height:'80px',
              backgroundColor: backgroundColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              padding: '10px',
              borderRadius: '50%',
              boxSizing: 'border-box',
            }
          }
        )}
      </div>
    )
  }
}

export default GamesIcon